<footer class="footer">
    <div class="footer-content justify-content-between">

    </div>
</footer>